import * as PropTypes from 'prop-types'

const SourceShape = PropTypes.shape({

})

export { SourceShape }
